import MachinesRequest from '../ws/MachinesRequest';
import MachinesStateRequest from '../ws/MachinesStatesRequest';
import Alert from 'react-s-alert';
import { I18nUtils } from '../../../i18n/I18nUtils';
import DocumentsSchemasRequest from '../../documents/ws/schemes/DocumentsSchemasRequest';
import DocumentSchemaType from '../../shared/model/DocumentSchemaType';
import MachineRequest from '../ws/MachineRequest';
import MachinesTypesRequest from '../ws/MachinesTypesRequest';

export const MACHINE_UPDATE = 'machine-update';
export const MACHINE_REMOVE = 'machine-remove';
export const MACHINES_UPDATE = 'machines-update';
export const MACHINES_LOADING = 'machines-loading';
export const MACHINES_ERROR = 'machines-error';
export const MACHINES_STATE_UPDATE = 'machines-state-update';
export const MACHINES_TYPES_UPDATE = 'machines-types-update';
export const MACHINES_TYPES_LOADING = 'machines-types-loading';

export const MACHINE_ADD_LOADING = 'machine-add-loading';

export const MACHINE_DOCUMENT_SCHEMA_TYPE = 'machine-document-schema-type';

export const getMachines = (
    page = 1,
    search = '',
    filter = 0,
    companyId = null,
    includeOnlyContractorMachines = false,
    includeOnlyCompanyMachines = false,
) => (dispatch) => {

    new MachinesRequest(
        page,
        search,
        filter,
        companyId,
        false,
        includeOnlyContractorMachines,
        includeOnlyCompanyMachines,
    )
        .onPreExecution(() => {
            dispatch({
                type: MACHINES_LOADING,
                payload: true,
            });
        })
        .onSuccess(data => {
            dispatch({
                type: MACHINES_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({
                type: MACHINES_ERROR,
                payload: error,
            });
        })
        .onPostExecution(() => {
            dispatch({
                type: MACHINES_LOADING,
                payload: false,
            });
        })
        .execute();
};

export const getMachinesDeleted = (page = 1, search = '', filter = 0, companyId = null) => (dispatch) => {
    new MachinesRequest(page, search, filter, companyId, true)
        .onPreExecution(() => {
            dispatch({ type: MACHINES_LOADING, payload: true });
        })
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: MACHINES_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({ type: MACHINES_ERROR, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: MACHINES_LOADING, payload: false });
        })
        .execute();
};

export const getMachine = (id) => (dispatch) => {
    new MachineRequest(id)
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: MACHINE_UPDATE,
                payload: data,
            });
        })
        .execute();
};

export const getMachinesStates = () => (dispatch) => {

    new MachinesStateRequest()
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: MACHINES_STATE_UPDATE,
                payload: data,
            });
        })
        .execute();
};

export const getDocumentSchemaState = () => (dispatch) => {

    new DocumentsSchemasRequest(DocumentSchemaType.MACHINE)
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: MACHINE_DOCUMENT_SCHEMA_TYPE,
                payload: data.data,
            });
        })
        .execute();
};

export const getMachineTypes = () => (dispatch) => {

    new MachinesTypesRequest()
        .onPreExecution(
            () => {
                dispatch({
                    type: MACHINES_TYPES_LOADING,
                    payload: true,
                });
            },
        )
        .onSuccess(
            data => {
                dispatch({
                    type: MACHINES_TYPES_UPDATE,
                    payload: data.data,
                });
            },
        )
        .onFail(error => {
            Alert.error(error || I18nUtils.tr('TR_UPDATE_MACHINE_ERROR'));
        })
        .onPostExecution(
            () => {
                dispatch({
                    type: MACHINES_TYPES_LOADING,
                    payload: false,
                });
            },
        )
        .execute();
};



// WEBPACK FOOTER //
// ./src/app/machines/actions/machineActions.js